import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { FileText, Eye, AlertCircle, CheckCircle, Image as ImageIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Documents = () => {
  const { user } = useAuth();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocuments = async () => {
      if (!user) {
        setLoading(false);
        return;
      }
      
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_API_URL}api/get-swimming-records`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        
        const data = await response.json();
        if (data.status === 'success') {
          // Find the user's applications
          const userApps = data.data.filter(app => app.student_id == user.id);
          
          if (userApps.length > 0) {
            // Get the most recent application
            const latestApp = userApps[userApps.length - 1]; 
            
            // Map the API fields to our UI document format
            const docs = [
              { name: 'Passport Photo', url: latestApp.photo_applicant },
              { name: 'Applicant Signature', url: latestApp.sign_applicant },
              { name: 'Father Declaration', url: latestApp.declaration_by_father },
              { name: 'Medical Certificate', url: latestApp.medical_certificate }
            ].filter(doc => doc.url); // Only include if the URL actually exists
            
            setDocuments(docs);
          }
        }
      } catch (error) {
        console.error('Error fetching documents:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, [user]);

  return (
    <div className="dashboard-container">
      <Header />
      <div className="dashboard-wrapper">
        <Sidebar activeItem="documents" />
        <div className="flex-grow-1 dashboard-content">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="page-title mb-0">My Uploaded Documents</h2>
            {!loading && documents.length > 0 && (
              <div className="badge bg-primary rounded-pill px-3 py-2">
                {documents.length} Document(s) Found
              </div>
            )}
          </div>
          
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : documents.length === 0 ? (
             <div className="alert border-0 d-flex align-items-center gap-3 p-4" style={{ backgroundColor: '#e8f4fd', borderRadius: '16px' }}>
                <div style={{ color: '#0d6efd' }}><AlertCircle size={28} /></div>
                <div>
                  <strong className="d-block text-dark mb-1 fs-5">No Documents Found</strong>
                  <span className="text-secondary">You haven't submitted any applications with documents yet.</span>
                </div>
              </div>
          ) : (
            <div className="row g-4">
              {documents.map((doc, index) => (
                <div key={index} className="col-md-6 col-lg-4">
                  <div className="document-card h-100 uploaded">
                    <div className="card-body p-0">
                      <div className="d-flex align-items-start p-3 pb-2">
                        <div className="document-status-icon uploaded me-2">
                          <CheckCircle size={16} />
                        </div>
                        <div className="document-info flex-grow-1">
                          <h6 className="mb-1">{doc.name}</h6>
                          <small className="document-status-text uploaded">
                            Uploaded
                          </small>
                        </div>
                      </div>
                      
                      <div className="px-3 pb-3">
                        <div className="document-file-preview">
                          <div className="document-file-info d-flex align-items-center justify-content-between w-100">
                            <div className="d-flex align-items-center">
                              <FileText size={14} className="document-file-icon me-2" />
                              <span className="document-file-name text-truncate" style={{ maxWidth: '120px', display: 'inline-block', verticalAlign: 'bottom' }}>
                                View File
                              </span>
                            </div>
                            <button 
                              className="btn btn-sm btn-outline-primary ms-auto"
                              onClick={() => window.open(doc.url, '_blank')}
                              title="View document"
                            >
                              <span className="small">View</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Documents;
